import {BrowserRouter} from "react-router-dom";

const BASE_PATH = process.env.REACT_APP_BASENAME || '/';

const history = (new BrowserRouter({basename: BASE_PATH})).history; // THIS IS BAD BUT ONLY SOLUTION NOW... NEW TO UPDATE PACKAGES

export default history